export const getUserName = () => {
  const storedName = localStorage.getItem('name')?.trim();
  if (storedName) {
    return storedName.charAt(0).toUpperCase() + storedName.slice(1);
  }
  return 'User';
};
